import { EventType } from '../../../../types'
import { SwiperReactFacadeSlide } from '../..'
import { UrlFactory } from '../../../../utils/urlFactory'
import { cdnClient } from '@vista/omnichannel-components-domain'
import React from 'react'

export type SlideProps = {
    event: EventType
    numberOfSlides: number
}

export const Slide: React.FC<SlideProps> = props => {
    const { event, numberOfSlides } = props
    const urlFactory = new UrlFactory(event.workflow)

    function getEventStill(event: EventType): string {
        return cdnClient.instance.event(event.eventId).gallery()
    }

    const imgSrc = getEventStill(event)
    const eventPictureSettings = getEventPictureSettings(numberOfSlides)

    if (!event.title || !event.eventId) return null

    return (
        <SwiperReactFacadeSlide>
            <a className="event-slide" href={urlFactory.getEventDetailsUrl(event.title, event.eventId)}>
                {imgSrc ? (
                    <picture className="event-slide__image">
                        {eventPictureSettings.sources.map(source => (
                            <source
                                media={`(max-width:${source.mediaMaxWidth}px)`}
                                srcSet={getImgSrcWithSizeParams(imgSrc, source.dimensions)}
                            />
                        ))}
                        <img
                            src={getImgSrcWithSizeParams(imgSrc, eventPictureSettings.defaultImgSrcsetDimensions)}
                            alt={event.title}
                        />
                    </picture>
                ) : (
                    <img className="event-slide__image" alt="image not found" />
                )}

                <div className="event-slide__details">
                    <h3>{event.title}</h3>
                </div>
            </a>
        </SwiperReactFacadeSlide>
    )
}

type DimensionsType = {
    width?: number | string
    height?: number | string
}

type eventPictureSettingsType = {
    defaultImgSrcsetDimensions: DimensionsType
    sources: {
        dimensions: DimensionsType
        mediaMaxWidth: number
    }[]
}

function getEventPictureSettings(numberOfSlides: number): eventPictureSettingsType {
    let defaultImgSrcsetDimensions
    if (numberOfSlides > 1) {
        if (numberOfSlides === 2) {
            defaultImgSrcsetDimensions = { width: 588, height: 162 }
        } else if (numberOfSlides === 3) {
            defaultImgSrcsetDimensions = { with: 385, height: 162 }
        } else if (numberOfSlides > 3) {
            defaultImgSrcsetDimensions = { width: 289, height: 162 }
        } else {
            defaultImgSrcsetDimensions = { width: '', height: '' }
        }

        return {
            defaultImgSrcsetDimensions,
            sources: [
                { mediaMaxWidth: 425, dimensions: { width: 325, height: 162 } },
                { mediaMaxWidth: 768, dimensions: { width: 610, height: 162 } },
            ],
        }
    } else if (numberOfSlides === 1) {
        defaultImgSrcsetDimensions = { width: 608, height: 324 }
        return {
            defaultImgSrcsetDimensions,
            sources: [
                { mediaMaxWidth: 425, dimensions: { height: 200 } },
                { mediaMaxWidth: 767, dimensions: { height: 200 } },
            ],
        }
    }
}

function getImgSrcWithSizeParams(imgSrc, dimensionQueryParams: DimensionsType) {
    const params = Object.keys(dimensionQueryParams)
        .map(key => {
            const value = dimensionQueryParams[key]
            return value ? `${key}=${value}` : null
        })
        .filter(item => item)
        .join('&')
    return `${imgSrc}?${params}`
}
